import React from "react";

import { Grid } from "@mui/material";

import { Comment } from "../../../../../../../components/Generic/GeneralComments/Comment";
import { GeneralComments } from "../../../../../../../models/general.comments";
import { CommentContainer } from "./styles";

interface Props {
  comments?: GeneralComments[];
}

export const CommentsTab = ({ comments }: Props) => {
  return (
    <Grid container direction="row" alignItems="center">
      {comments &&
        comments?.length > 0 &&
        comments?.map((comment: GeneralComments) => (
          <CommentContainer key={comment.id} item xs={12}>
            <Comment comment={comment} isViewMode={true} />
          </CommentContainer>
        ))}
    </Grid>
  );
};
